// extracted by mini-css-extract-plugin
export default {"delete":"Sites_delete__-wuLN"};